import React from "react";
import LottieAnimation from "us.common/components/Lottie";
import { LoadingAnimation } from "us.common/components/animations";
export default ({ isDescriptionAvailable = false }) => (
  <div
    style={{
      position: "absolute",
      left: "0",
      right: "0",
      top: "0",
      bottom: "0",
      display: "flex",
      alignContent: "center",
      textAlign: "center",
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "center",
      backgroundColor: "#ffffff",
      zIndex: 9999,
      paddingBottom: "5%",
    }}
  >
    <h1
      className="mb-4 text-primary"
      style={{
        fontSize: 24,
        fontWeight: "700",
      }}
    >
      UnicornBOX
    </h1>
    <div
      style={{
        width: "100%",
      }}
    >
      <LottieAnimation lotti={LoadingAnimation} width={"35%"} />
    </div>
    {isDescriptionAvailable && (
      <h4
        className="mt-4"
        style={{
          fontSize: 18,
          fontWeight: "400",
        }}
      >
        Getting things ready…
      </h4>
    )}
  </div>
);
